import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const TipiUfficiContext = React.createContext(null);

const { Provider } = TipiUfficiContext;

export const TipiUfficiProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        tipiUffici: { result: [], totalCount: 0, },
    });

    const { tipiUffici } = state;

    const [isLoadingTipiUffici, setIsLoadingTipiUffici] = useState(false);
    const getTipiUfficiAsync = async (pageIndex = 0, pageSize = 100, term = null, padre = true,) => {
        try {
            setIsLoadingTipiUffici(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.GetTipiUffici({ pageIndex, pageSize, padre, term }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => { return { ...e, inizioValidita: new Date(e.inizioValidita), fineValidita: e.fineValidita ? new Date(e.fineValidita) : null, } });
            setState({ tipiUffici: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipiUffici(false);
        }
    }

    const [isDeletingTipoUfficio, setIsDeletingTipoUfficio] = useState(false);
    const deleteTipoUfficioAsync = async (tipoUfficioId,) => {
        try {
            setIsDeletingTipoUfficio(true);
            if (window.confirm("Confermare l'eliminazione?")){
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.DeleteTipoUfficio({ tipoUfficioId }), {
                method: HttpMethods.DELETE
            });
            showSuccessMessage(`Tipo con id ${tipoUfficioId} disabilitato`);
        }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingTipoUfficio(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingTipiUffici,
            getTipiUfficiAsync,

            isDeletingTipoUfficio,
            deleteTipoUfficioAsync,
        }}>
            {props.children}
        </Provider>
    );
}